import styled from 'styled-components';
import { BREAKPOINTS } from '../../constants/breakpoints';
import { SpinnerCircle } from '../spinner/spinner.styles';
import { FontSizes } from '../typography/typography.styles';

export const ModalParcelItemsPhotoSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  margin-bottom: 2.4rem;
  color: ${({ theme }) => theme.colors.baseColors.grey150};
  letter-spacing: 0.5px;

  * {
    font-family: inherit;
  }

  .photo-modal-header {
    display: flex;
    align-items: center;
    gap: 1.2rem;
  }

  .photo-modal-header svg {
    flex: 0 0 2rem;
    width: 2rem;
    height: 2rem;
  }

  h2,
  h3,
  p,
  figure {
    margin: 0;
  }

  h2 {
    font-size: ${FontSizes.mediumBig};
    font-weight: 700;
    line-height: 3rem;
  }

  .photo-guidelines {
    display: flex;
    gap: 1.6rem;
  }

  figure {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.8rem;
    min-width: 0;
  }

  figcaption {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    height: 2.4rem;
    font-size: ${FontSizes.mediumPlus};
    font-weight: 700;
    line-height: 2.4rem;
  }

  .guidance-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 2rem;
    width: 2rem;
    height: 2rem;
  }

  .guidance-icon svg {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }

  .guidance-photo {
    width: 100%;
    height: 22.8rem;
    overflow: hidden;
    border-radius: 1.2rem;
  }

  .guidance-photo > div,
  .guidance-photo img {
    width: 100%;
    height: 100%;
  }

  .guidance-photo img {
    display: block;
    object-fit: cover;
  }

  .guidance-photo .react-loading-skeleton {
    height: 100%;
    border-radius: inherit;
  }

  .photo-steps {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .photo-steps li {
    display: flex;
    align-items: flex-start;
    gap: 0.8rem;
  }

  .photo-steps span {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 2.4rem;
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.baseColors.blue5};
    color: ${({ theme }) => theme.colors.baseColors.blue100};
    font-size: ${FontSizes.small};
    font-weight: 500;
    line-height: 1.6rem;
  }

  .photo-steps p {
    padding-top: 0.2rem;
    font-size: ${FontSizes.normal};
    font-weight: 500;
    line-height: 2rem;
  }

  .file-selection {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
  }

  .file-selection h3 {
    margin-bottom: 0.8rem;
    font-size: ${FontSizes.mediumPlus};
    font-weight: 700;
    line-height: 2.4rem;
  }

  .file-input {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    white-space: nowrap;
  }

  .dropzone {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 13.3rem;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.colors.baseColors.blue50};
    border-radius: 1rem;
    background-color: ${({ theme }) => theme.colors.baseColors.grey5};
    transition:
      border-color 0.2s,
      background-color 0.2s;
  }

  .dropzone.is-dragging {
    border-color: ${({ theme }) => theme.colors.baseColors.blue100};
    background-color: ${({ theme }) => theme.colors.baseColors.blue5};
  }

  .upload-file-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 4rem;
    width: 4rem;
    height: 4rem;
  }

  .upload-file-icon svg {
    display: block;
    width: 2.4rem;
    height: 3.2rem;
  }

  .desktop-drop-copy,
  .file-hint {
    font-size: ${FontSizes.normal};
    line-height: 2rem;
  }

  .desktop-drop-copy {
    max-width: 100%;
    overflow: hidden;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .upload-file-button {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 1.2rem;
    width: 100%;
    height: 100%;
    padding: 1.2rem 2.4rem;
    border: 0;
    background: transparent;
    color: ${({ theme }) => theme.colors.baseColors.grey150};
    font-size: ${FontSizes.normal};
    cursor: pointer;
  }

  .upload-file-label {
    color: ${({ theme }) => theme.colors.baseColors.blue100};
    font-weight: 700;
    line-height: 1.6rem;
  }

  .upload-file-button:focus-visible {
    border-radius: 0.4rem;
    outline: 3px solid ${({ theme }) => theme.colors.baseColors.blue65};
  }

  .upload-file-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 1.6rem;
  }

  .upload-file-spinner ${SpinnerCircle} {
    width: 1.6rem;
    height: 1.6rem;
    border-width: 2px;
  }

  .attachment-list {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    margin-top: 0.8rem;
  }

  .attachment-item {
    display: flex;
    align-items: center;
    gap: 1.2rem;
    min-width: 0;
    padding: 0.4rem 0;
  }

  .attachment-type-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 4.8rem;
    width: 4.8rem;
    height: 4.8rem;
    border-radius: 1rem;
    background-color: ${({ theme }) => theme.colors.baseColors.blue5};
  }

  .attachment-type-icon > span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
  }

  .attachment-type-icon svg {
    display: block;
    width: 1.6rem;
    height: 1.6rem;
  }

  .attachment-details {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    gap: 0.4rem;
    min-width: 0;
  }

  .attachment-name,
  .attachment-size {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .attachment-name {
    font-size: ${FontSizes.normal};
    font-weight: 500;
    line-height: 2rem;
  }

  .attachment-size {
    color: ${({ theme }) => theme.colors.baseColors.grey80};
    font-size: ${FontSizes.small};
    font-weight: 400;
    line-height: 1.6rem;
  }

  .remove-attachment-button {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex: 0 0 2rem;
    width: 2rem;
    height: 2rem;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
  }

  .remove-attachment-button > span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
  }

  .remove-attachment-button svg {
    display: block;
    height: 2rem;

    color: ${({ theme }) => theme.colors.baseColors.red130};
  }

  .remove-attachment-button:focus-visible {
    border-radius: 0.4rem;
    outline: 3px solid ${({ theme }) => theme.colors.baseColors.blue65};
  }

  .file-hint {
    color: ${({ theme }) => theme.colors.baseColors.grey100};
    font-weight: 400;
  }

  .file-hint.is-error {
    color: ${({ theme }) => theme.colors.baseColors.red100};
  }

  @media (max-width: ${BREAKPOINTS.mobile.css}) {
    gap: 2.4rem;

    .photo-modal-header {
      justify-content: center;
    }

    h2 {
      font-size: ${FontSizes.mediumPlus};
      line-height: 2.4rem;
      text-align: center;
    }

    .photo-guidelines {
      gap: 0.8rem;
      margin-top: -1.2rem;
    }

    figure {
      gap: 0.4rem;
    }

    figcaption {
      gap: 0.4rem;
      height: 1.2rem;
      font-size: 1rem;
      line-height: 1.2rem;
    }

    .guidance-icon {
      flex-basis: 1.2rem;
      width: 1.2rem;
      height: 1.2rem;
    }

    .guidance-photo {
      height: 9.2rem;
      border-radius: 0.6rem;
    }

    .photo-steps p {
      padding-top: 0;
      font-size: ${FontSizes.medium};
      line-height: 2.2rem;
    }

    .file-selection h3 {
      font-size: ${FontSizes.mediumPlus};
      line-height: 2.4rem;
    }

    .dropzone {
      height: 10.5rem;
    }

    .desktop-drop-copy {
      display: none;
    }
  }
`;
